import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { Book } from "../../types/types";
export type BookBySlugDTO = Book

    type getCourseResponse = {
        statusCode?: number;
        error?: null | ApiError;
        data?: BookBySlugDTO;
      
    }
    export const GetBookBySlug = async (bookSlug: string): Promise<getCourseResponse> => {
        try {
            const response = await axios.get(`/book/bySlug/${bookSlug}`);
                    return { data: response.data };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            console.error("API Error:", error);
            if (error.response) {
                const apiError: ApiError = {
                    statusCode: error.response.status,
                    message: error.response.data.message,
                    error: error.response.data.error,
                };
                return { error: apiError };
            } else {
                const fallbackError: ApiError = {
                    statusCode: 500,
                    message: "An unexpected error occurred",
                };
                return { error: fallbackError };
            }
        }
    };
